document.addEventListener("DOMContentLoaded", function () {
  const tabsContainer = document.querySelector("ul.product-tabs");
  const sections = document.querySelectorAll(".product-page #MainContent .shopify-section");

  if (!tabsContainer || !sections) return;

  document.querySelector(".header").style.display = "block"; 

  sections.forEach((section, index) => {
    const tabElement = section.querySelector("[data-tab]");

    if (tabElement) {
      const tabValue = tabElement.getAttribute("data-tab");

      const li = document.createElement("li");
      li.textContent = tabValue;
      li.setAttribute("data-tab", tabValue);
      li.innerHTML = `<a href="#${section.getAttribute("id")}" class="scroll-link">${tabValue}</a>`
      
      if(index == 2 ) {
          // Add class here
        li.classList.add("is-selected")
      }
     

      tabsContainer.appendChild(li);

       li.addEventListener("click", ()=>{
          const selected = document.querySelector(".product-tabs .is-selected");
          console.log(selected)
          if (selected) selected.classList.remove("is-selected");

          li.classList.add("is-selected");
      });

        li.querySelector(".scroll-link").addEventListener('click', function(e) {
          e.preventDefault(); // Prevent default anchor behavior
          const targetId = this.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
            // Get element position minus 100px
            const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 200;
            window.scrollTo({
              top: offsetTop,
              behavior: 'smooth' // smooth scroll
            });
          }
        });
      
    } 
    // else if you want to handle .shopify-app-block, add here:
    // else if (section.querySelector(".shopify-app-block")) { 
    //   console.log(window.tabsTranslation.reviews)
    //  }
  });
});

window.addEventListener('scroll', () => {
  document.querySelectorAll(".product-page #MainContent .shopify-section")?.forEach(section => {
  
    const id = section.querySelector("[data-tab]")?.getAttribute("data-tab")
    if( document.querySelector(`.product-tabs li[data-tab="${id}"]`)) {
      const rect = section.getBoundingClientRect();
      const inView = rect.top < 300 ;

      if ( inView) {
        
        const selected = document.querySelector(".product-tabs .is-selected");
        if (selected) selected.classList.remove("is-selected");

        const newItem = document.querySelector(`.product-tabs li[data-tab="${id}"]`);
        if (newItem) newItem.classList.add("is-selected");
      }
    }
   
  });
});
